// Development: used by `ng serve` and `ng build --configuration development`.
// Production builds replace this file with environment.prod.ts (see angular.json).
export const environment = {
  production: false,
  apiBaseUrl: 'https://rssdi.microwarecomp.com/api/v1',
  // host for uploaded / import-error files
  fileHostUrl: 'https://rssdi.microwarecomp.com'
};
